import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { StyledIconContainer, ActionIconStyles } from '../index.css'

type ActionIconProps = {
  children: React.ReactElement
  message: string
}

type StyledActionIconProps = {
  isWithText: boolean
  mode: Theme
}

const StyledActionIcon = styled.div<StyledActionIconProps>`
  ${ActionIconStyles}
  padding: ${({ isWithText }) => (isWithText ? '3px 8px 3px 10px' : '5px 8px')};
  &:hover {
    border-radius: ${({ isWithText }) => (isWithText ? '0' : '50%')};
    background: ${({ mode }) => sys[mode].interaction.onElevation.default};
  }
`

const ActionIcon = ({ children, message }: ActionIconProps) => {
  const theme = useDisplayTheme() as Theme
  const isWithText = !!message

  return (
    <StyledActionIcon mode={theme} isWithText={isWithText}>
      <StyledIconContainer> {children}</StyledIconContainer>
      {message}
    </StyledActionIcon>
  )
}

export default ActionIcon
